import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Search from '@ifeng-fe/ui_pc_search';
import rel from '@ifeng-fe/container_channel/common/client/utils/rel';
import NoSSR from 'react-no-ssr';

/**
 * for this page
 */

class Nav extends React.PureComponent {
    state = {
        IsShowStyle: styles.hidden,
        sBoxIsShow: false,
    };
    static propTypes = {
        searchData: PropTypes.array,
    };

    searchBtnHandle = () => {
        this.setState({
            sBoxIsShow: !this.state.sBoxIsShow,
        });
    };

    render() {
        // console.log(this.props);
        const { searchData } = this.props;

        return (
            <div className={styles.nav}>
                <div className={styles.wrapper}>
                    <div>
                        <div className={styles.h_logo}>
                            <img src="http://p0.ifengimg.com/fe/zxyc-index/images/logo1_823c17f4.png" />
                        </div>
                        <div className={styles.h_logo_r}>凤凰资讯出品</div>
                        <div className={styles.h_nav}>
                            <a href="http://www.ifeng.com/" target="_blank" rel={rel}>
                                凤凰网首页
                            </a>
                            |
                            <a href="http://news.ifeng.com/" target="_blank" rel={rel}>
                                凤凰资讯
                            </a>
                        </div>
                    </div>
                    <div className={styles.LogLis}>
                        <div className={styles.Login}>
                            <NoSSR>
                                <UserInfo iconShow option={['login']} />
                            </NoSSR>
                        </div>
                        <div className={`${styles.Search} clearfix`}>
                            <a
                                className={this.state.sBoxIsShow ? this.state.IsShowStyle : styles.searchBtn}
                                href="javascript:;"
                                onClick={this.searchBtnHandle}
                                rel={rel}>
                                查找
                            </a>
                            <div className={this.state.sBoxIsShow ? styles.fl : this.state.IsShowStyle}>
                                <NoSSR>
                                    <Chip
                                        id="10129"
                                        type="static"
                                        title="通用搜索"
                                        groupName="顶部导航"
                                        content={searchData}>
                                        <Search />
                                    </Chip>
                                </NoSSR>
                            </div>
                            <div
                                className={this.state.sBoxIsShow ? styles.srhClose : this.state.IsShowStyle}
                                onClick={this.searchBtnHandle}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Nav);
